import type { IconSvgObject } from './types';

const Mouse18Icon: IconSvgObject = [
  ["path", { d: "M12 7V2.5M12 13V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 8C13.5 7.44772 13.0523 7 12.5 7H11.5C10.9477 7 10.5 7.44772 10.5 8V10C10.5 10.5523 10.9477 11 11.5 11H12.5C13.0523 11 13.5 10.5523 13.5 10V8Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.5 12.5C4.5 9 5.5 6 6 5C8 4.5 11 3 12 2C13 3 16 4.5 18 5C18.5 6 19.5 9 19.5 12.5C19.5 16 17.5 20 12 22C6.5 20 4.5 16 4.5 12.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Mouse18Icon;
